import { defineStore } from "pinia";

export const useWeeklyReportStore = defineStore("weeklyReport", {
  state: () => ({
    isDialogVisible: false,
  }),
  actions: {
    showDialog() {
      this.isDialogVisible = true;
    },
    hideDialog() {
      this.isDialogVisible = false;
    },
  },
});
